export interface ITenantWorkType {
  workTypeId: number;
  certificationTypeIds: number[];
}

export interface ITenantWorkConfig {
  certificationTypeIds: number[];
  workTypes: ITenantWorkType[];
}

const positiveIds = (value: unknown): number[] => {
  if (!Array.isArray(value)) return [];
  const ids = value
    .map((item) => (typeof item === 'number' ? item : Number(item)))
    .filter((item) => Number.isInteger(item) && item > 0);
  return [...new Set(ids)];
};

export const emptyTenantWorkConfig = (): ITenantWorkConfig => ({
  certificationTypeIds: [],
  workTypes: [],
});

export const parseTenantWorkConfig = (tenant: {
  certificationTypeIds?: unknown;
  workTypes?: unknown;
}): ITenantWorkConfig => {
  const seen = new Set<number>();
  const workTypes = Array.isArray(tenant.workTypes)
    ? tenant.workTypes.flatMap((item) => {
        if (!item || typeof item !== 'object') return [];
        const workTypeId = Number(
          (item as { workTypeId?: unknown }).workTypeId
        );
        if (!Number.isInteger(workTypeId) || workTypeId <= 0) return [];
        if (seen.has(workTypeId)) return [];
        seen.add(workTypeId);
        return [
          {
            workTypeId,
            certificationTypeIds: positiveIds(
              (item as { certificationTypeIds?: unknown }).certificationTypeIds
            ),
          },
        ];
      })
    : [];

  return {
    certificationTypeIds: positiveIds(tenant.certificationTypeIds),
    workTypes,
  };
};

export const tenantWorkConfigSnapshot = (config: ITenantWorkConfig): string =>
  JSON.stringify({
    certificationTypeIds: [...config.certificationTypeIds].sort(
      (left, right) => left - right
    ),
    workTypes: [...config.workTypes]
      .map((item) => ({
        workTypeId: item.workTypeId,
        certificationTypeIds: [...item.certificationTypeIds].sort(
          (left, right) => left - right
        ),
      }))
      .sort((left, right) => left.workTypeId - right.workTypeId),
  });
